/* Ponte fra la nostra buy-box e il carrello a tendina di Dawn.
   Su Impulse il drawer era jQuery piu' #CartDrawer. Dawn usa l'elemento
   <cart-drawer>, che si aggiorna con renderContents() e si apre da solo.
   av-ki-pdp.liquid chiama window.avkApriDrawer() dopo /cart/add.js:
   se qui torniamo true, non si va mai sulla pagina /cart.

   10/10/2026 - due cose in piu', senza le quali il cassetto si apriva bianco:

   1. la classe is-empty. Dawn la toglie da <cart-drawer> dentro product-form.js
      (riga 104), che e' il pezzo che la nostra buy-box scavalca. renderContents
      la toglie solo da .drawer__inner, quindi al PRIMO prodotto aggiunto il CSS
      (component-cart-drawer.css:47) continuava a nascondere tutto.
   2. l'aggancio a 'cart-update'. Dawn non ha jQuery, e i nostri due pezzi
      (barra spedizione e cross-sell) erano scritti per gli eventi di Impulse.
      Quando il cliente cambia quantita' dentro il cassetto passa da cart.js,
      non da qui: senza questo aggancio la barra restava ferma. */
window.avkApriDrawer = function () {
  var d = document.querySelector('cart-drawer');
  if (!d || typeof d.renderContents !== 'function') return false;

  var ids = d.getSectionsToRender().map(function (s) { return s.id; });
  fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')), {
    credentials: 'same-origin'
  })
    .then(function (r) { if (!r.ok) throw new Error('sezioni'); return r.json(); })
    .then(function (sections) {
      d.classList.remove('is-empty');
      d.renderContents({ sections: sections });
      avkAggiornaPezzi();
    })
    .catch(function () { window.location.href = '/cart'; });

  return true;
};

function avkAggiornaPezzi() {
  if (window.avkShipRefresh) window.avkShipRefresh();
  if (window.avkXsellRefresh) window.avkXsellRefresh();
}
window.avkAggiornaPezzi = avkAggiornaPezzi;

/* 'cart-update' e' la costante cartUpdate di constants.js: la pubblicano
   cart.js (quantita' e rimozioni) e product-form.js. Qui sotto 'subscribe'
   arriva da pubsub.js, caricato prima di questo file. */
if (typeof subscribe === 'function') {
  subscribe('cart-update', function () { setTimeout(avkAggiornaPezzi, 60); });
}
